module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-01-022b204bf8df0488f5c507198492f9ea.jpg";